<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备导入
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="toAddNew">导入</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="应用系统" prop="system_id">
                <el-select :popper-append-to-body="false" v-model="seefrom.system_id" placeholder="请选择应用系统" @change="selectDeviceType">
                  <el-option v-for="item in SystemId" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select :popper-append-to-body="false" placeholder="请输入设备类型" v-model="seefrom.device_type">
                  <el-option :value="''">请选择</el-option>
                  <el-option v-for="item in options" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备厂家">
                <el-input placeholder="请输入设备厂家" v-model="seefrom.factory"></el-input>
              </el-form-item>
              <el-form-item label="设备型号">
                <el-input placeholder="请输入设备型号" v-model="seefrom.model"></el-input>
              </el-form-item>
              <br />
              <el-form-item label="开始时间" prop="startTime">
                <el-date-picker v-model="seefrom.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker v-model="seefrom.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <!-- 后端分页 -->
          <easyTable apiUrl="operation/inpDevice/findBatchs" :parent="self" :config="config" :other="other" ref="deviceList" :height="400">
            <template slot="last">
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-link icon="iconfont iconcheck" type="text" size="small" @click="seeAll(scope.$index, scope.row)">导入详情</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- 弹出框 -->
        <el-dialog class="editDialog" :visible.sync="displayForm" :title="title" :close-on-click-modal="false">
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="应用系统" prop="system_id">
              <el-select :popper-append-to-body="false" v-model="addEquipment.system_id" placeholder="请选择应用系统" @change="selectDeviceType">
                <el-option v-for="item in SystemId" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型" prop="device_type">
              <el-select :popper-append-to-body="false" placeholder="请输入设备类型" v-model="addEquipment.device_type" @change="changeEquipment">
                <el-option :value="''">请选择</el-option>
                <el-option v-for="item in options" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产厂商" prop="factory">
              <el-select :popper-append-to-body="false" v-model="addEquipment.factory" value placeholder="请选择生产厂商" @change="initDeviceMode">
                <el-option v-for="item in factoryList" :key="'F' + item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备型号" prop="model">
              <el-select :popper-append-to-body="false" v-model="addEquipment.pumpType" value placeholder="请选择设备型号" @change="deviceModeChange">
                <el-option v-for="item in deviceModeList" :key="'M' + item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="导入文件">
              <input id="test" type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" accept=".xlsx" />
            </el-form-item>
          </el-form>
          <a style="color: #4c6bc3; font-size: 12px; margin: 0 0 0 290px" href="/static/导入模板.xlsx" download="导入模板.xlsx">导入模板下载：导入模板.xlsx</a>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog class="editDialog" :visible.sync="seeDisplayForm" title="导入详情" :close-on-click-modal="false">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" max-height="500px" ref="Table">
            <el-table-column prop="imei" label="imei"> </el-table-column>
            <el-table-column prop="device_name" label="名称"> </el-table-column>
          </el-table>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        system_id: [{ required: true, message: '请输入应用系统', trigger: 'blur' }],
        device_type: [{ required: true, message: '请输入设备类型', trigger: 'blur' }],
        factory: [{ required: true, message: '请输入设备厂家', trigger: 'blur' }],
        model: [{ required: true, message: '请输入设备型号', trigger: 'blur' }],
      },
      tabName: 'jsgl',
      form_jsgl: {},
      title: '',
      other: {},
      items: [],
      seefrom: {
        system_id: '',
        device_type: '',
        factory: '',
        model: '',
        startTime: '',
        endTime: '',
      },
      addEquipment: {
        system_id: '',
        device_type: '',
        factory: '',
        model: '',
        pumpType: null,
      },
      seeDisplayForm: false,
      displayForm: false,
      SystemId: [],
      factoryList: [],
      options: [],
      deviceModeList: [],
      //上传文件
      addArr: [],
      tableData: [],
      //设备额外信息
      equipment: {
        protocolTypeName: '',
      },
      //设备种类（网关）
      deviceKind: '',
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'batch',
          label: '导入批次',
        },
        {
          prop: 'create_time',
          label: '导入时间',
        },
        {
          prop: 'systemName',
          label: '应用系统',
        },
        {
          prop: 'deviceTypeName',
          label: '设备类型',
        },
        {
          prop: 'factory',
          label: '设备厂家',
        },
        {
          prop: 'model',
          label: '设备型号',
        },
        {
          prop: 'total',
          label: '导入数量',
        },
      ]
    },
    dt() {
      return dt.map(({ label }) => label)
    },
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
  },
  methods: {
    //初始化
    initSystemId() {
      //console.log("应用系统");
      this.$axiosget('manager/operatingSystemApi/getOperatingSystemsByCompanyId', {
        params: {
          compayId: localStorage.getItem('companyId'),
        },
      }).then((res) => {
        this.SystemId = res.data.data
      })
    },
    //设备类型
    selectDeviceType(value) {
      this.seefrom.device_type = ''
      //console.log(value, "id");
      this.$axiosget('manager/operatingSystemApi/getDeviceTypeByOperatingId', {
        params: {
          id: value,
        },
      }).then((res) => {
        this.options = res.data.data
        //console.log(this.options, "options");
      })
    },
    //设备类型变更
    changeEquipment(val) {
      this.equipment = this.options.find((e) => val === e.id)
      //console.log(this.equipment, "equipment");
      //判断设备种类
      this.deviceKind = this.equipment.deviceKind
      this.addEquipment.protocolType = this.equipment.protocolType
    },
    //初始化厂家
    initDeviceFactory() {
      this.addEquipment.model = ''
      let params = {
        key: 'FACTORY',
        pageSize: 99,
        pageNum: 1,
      }
      this.$axiosget('operation/dictionaryType/queryList', {
        params: params,
      }).then((res) => {
        if (res.data.status === '10000') {
          this.factoryList = res.data.data.list
        } else {
          this.factoryList = []
        }
      })
    },
    //设备型号变更
    deviceModeChange() {
      let deviceMode = this.addEquipment.pumpType
      let temp = this.deviceModeList.find((it) => it.id === deviceMode)
      if (temp) {
        this.addEquipment.model = temp.name
      }
    },
    initDeviceMode(value) {
      var dic_type = ''
      this.factoryList.forEach((element) => {
        if (element.name === value) {
          dic_type = element.id
        }
      })
      this.$axiosget('operation/dictionaryData/queryList', {
        params: {
          dicType: dic_type,
        },
      }).then((res) => {
        if (res.data.status === '10000') {
          this.deviceModeList = res.data.data.list
        }
      })
    },
    //上传文件
    getFile(event) {
      var file = event.target.files
      this.addArr = []
      // for (var i = 0; i < file.length; i++) {
      //    上传类型判断
      var imgName = file[file.length - 1].name
      var idx = imgName.lastIndexOf('.')
      if (idx != -1) {
        var ext = imgName.substr(idx + 1).toUpperCase()
        ext = ext.toLowerCase()
        if (ext === 'xlsx') {
          this.addArr = file[file.length - 1]
          //console.log(this.addArr, "addArr");
        } else {
          this.$message.error('文件类型错误！')
        }
      }
      // }
    },
    subSeefrom() {
      this.other = this.seefrom
      this.$refs.deviceList.pageToOne()
      this.$nextTick(this.$refs.deviceList.getData)
    },
    reset() {
      this.seefrom = {
        system_id: '',
        device_ype: '',
        factory: '',
        model: '',
        startTime: '',
        endTime: '',
      }
    },
    //导入详情
    seeAll(index, row) {
      this.seeDisplayForm = true
      this.$axiosget('operation/inpDevice/findDeviceByBatchId/'.concat(row.id)).then((res) => {
        this.tableData = res.data.data
      })
    },
    //新增
    toAddNew() {
      this.addArr = []
      var test = document.getElementById('test')
      if (test) {
        test.value = ''
      }
      this.title = '设备导入'
      this.addEquipment = {
        system_id: '',
        device_type: '',
        factory: '',
        model: '',
      }
      this.displayForm = true
      if (this.$refs['addEquipment']) {
        this.$refs['addEquipment'].clearValidate()
      }
    },
    //确认
    submitForm() {
      //console.log(this.addArr);
      if (this.addArr.length === 0) {
        this.$notify({
          message: '请选择文件！',
          type: 'warning',
        })
        return
      } else {
        var formData = new FormData()
        formData.append('file', this.addArr)
        formData.append('model', this.addEquipment.model)
        formData.append('device_type', this.addEquipment.device_type)
        formData.append('system_id', this.addEquipment.system_id)
        formData.append('factory', this.addEquipment.factory)
        formData.append('device_kind', this.deviceKind)
        formData.append('protocolType', this.addEquipment.protocolType)
        formData.append('pump_type', this.addEquipment.pumpType)

        this.$refs['addEquipment'].validate((valid) => {
          if (valid) {
            this.displayForm = false
            //console.log(this.addArr, "submit");
            this.$axiospost('operation/inpDevice/add', formData).then((res) => {
              if (res.data.status === '10000') {
                this.subSeefrom()
                this.$message.success('导入成功' + res.data.data.success + '条，失败' + res.data.data.error + '条')
              }
            })
          }
        })
      }
    },
  },
  mounted() {
    this.initSystemId()
    this.initDeviceFactory()
  },
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/deviceLead.vue